// src/pages/Login.js
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");

  const { login }   = useAuth();
  const navigate    = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const result = await login(email, password);
      if (result.success) {
        navigate("/dashboard");
      } else {
        setError(result.message || "Invalid credentials.");
      }
    } catch (err) {
      setError("Connection error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.wrapper}>
      <div style={s.bgGlow1}></div>
      <div style={s.bgGlow2}></div>
      <div style={s.bgGrid}></div>

      <div style={s.card}>
        {/* Logo */}
        <div style={s.logoWrap}>
          <div style={s.logoRing}><span style={s.logoText}>iDH</span></div>
          <div style={s.brandName}>
            <span style={s.brandI}>i</span>
            <span style={s.brandRest}>Digital Hub</span>
          </div>
          <div style={s.pvtLtd}>Pvt. Ltd.</div>
        </div>

        {/* Panel Title */}
        <div style={s.titleRow}>
          <div style={s.line}></div>
          <span style={s.panelTitle}>i-Panel</span>
          <div style={s.line}></div>
        </div>
        <p style={s.subtitle}>Command Center — Authorized Access Only</p>

        {/* Form */}
        <form onSubmit={handleLogin} style={s.form}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Email Address</label>
            <div style={s.inputWrap}>
              <span style={s.icon}>✉</span>
              <input
                type="email" value={email} required
                onChange={e => setEmail(e.target.value)}
                placeholder="admin@idigitalhub.com"
                style={s.input}
                onFocus={e => e.target.parentNode.style.borderColor="#D4A017"}
                onBlur={e  => e.target.parentNode.style.borderColor="rgba(212,160,23,0.15)"}
              />
            </div>
          </div>

          <div style={s.fieldGroup}>
            <label style={s.label}>Password</label>
            <div style={s.inputWrap}>
              <span style={s.icon}>🔒</span>
              <input
                type={showPass?"text":"password"} value={password} required
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••••"
                style={s.input}
                onFocus={e => e.target.parentNode.style.borderColor="#D4A017"}
                onBlur={e  => e.target.parentNode.style.borderColor="rgba(212,160,23,0.15)"}
              />
              <span onClick={()=>setShowPass(!showPass)} style={s.eyeBtn}>
                {showPass ? "🙈" : "👁"}
              </span>
            </div>
          </div>

          {error && (
            <div style={s.errorBox}>⚠ {error}</div>
          )}

          <button type="submit" style={s.btn} disabled={loading}>
            {loading ? "Authenticating..." : "Login to i-Panel →"}
          </button>
        </form>

        <div style={s.footer}>
          <span style={s.footerText}>🔐 Secured with SSL</span>
          <span style={s.dot}>•</span>
          <span style={s.footerText}>iDigital Hub Pvt. Ltd.</span>
        </div>
      </div>

      <div style={s.bottomTag}>i-Panel v1.0 — Internal Use Only</div>
    </div>
  );
}

const s = {
  wrapper:   { minHeight:"100vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", background:"#080810", position:"relative", overflow:"hidden", padding:20 },
  bgGlow1:   { position:"absolute", top:-200, left:-200, width:600, height:600, background:"radial-gradient(circle, rgba(212,160,23,0.12) 0%, transparent 70%)", pointerEvents:"none" },
  bgGlow2:   { position:"absolute", bottom:-200, right:-100, width:500, height:500, background:"radial-gradient(circle, rgba(233,30,140,0.10) 0%, transparent 70%)", pointerEvents:"none" },
  bgGrid:    { position:"absolute", inset:0, backgroundImage:"linear-gradient(rgba(212,160,23,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(212,160,23,0.03) 1px, transparent 1px)", backgroundSize:"40px 40px", pointerEvents:"none" },
  card:      { background:"#0F0F1A", border:"1px solid rgba(212,160,23,0.12)", borderRadius:20, padding:"44px 40px", width:"100%", maxWidth:440, position:"relative", boxShadow:"0 40px 120px rgba(0,0,0,0.8)" },
  logoWrap:  { display:"flex", flexDirection:"column", alignItems:"center", gap:10, marginBottom:28 },
  logoRing:  { width:72, height:72, borderRadius:"50%", background:"linear-gradient(135deg, #D4A017, #F0C040, #A07810)", display:"flex", alignItems:"center", justifyContent:"center", boxShadow:"0 0 30px rgba(212,160,23,0.4)" },
  logoText:  { fontSize:22, fontWeight:800, color:"#0A0A0F", letterSpacing:-1 },
  brandName: { display:"flex", alignItems:"baseline", gap:2 },
  brandI:    { fontSize:22, fontWeight:800, background:"linear-gradient(135deg, #D4A017, #F0C040)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" },
  brandRest: { fontSize:20, fontWeight:600, color:"#F0F0F0" },
  pvtLtd:    { fontSize:11, color:"#505060", letterSpacing:2, textTransform:"uppercase" },
  titleRow:  { display:"flex", alignItems:"center", gap:14, marginBottom:8 },
  line:      { flex:1, height:1, background:"linear-gradient(90deg, transparent, rgba(212,160,23,0.4))" },
  panelTitle:{ fontSize:13, fontWeight:700, letterSpacing:4, textTransform:"uppercase", background:"linear-gradient(135deg, #D4A017, #F0C040)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" },
  subtitle:  { textAlign:"center", fontSize:12, color:"#505060", marginBottom:32, letterSpacing:0.5 },
  form:      { display:"flex", flexDirection:"column", gap:20 },
  fieldGroup:{ display:"flex", flexDirection:"column", gap:8 },
  label:     { fontSize:12, fontWeight:600, color:"#9090A0", letterSpacing:1, textTransform:"uppercase" },
  inputWrap: { display:"flex", alignItems:"center", background:"#14141F", border:"1px solid rgba(212,160,23,0.15)", borderRadius:10, overflow:"hidden", transition:"border-color 0.2s" },
  icon:      { padding:"0 14px", fontSize:16, color:"#505060" },
  input:     { flex:1, padding:"14px 0", background:"transparent", border:"none", color:"#F0F0F0", fontSize:15, outline:"none", fontFamily:"inherit" },
  eyeBtn:    { padding:"0 16px", cursor:"pointer", fontSize:16, color:"#505060", userSelect:"none" },
  errorBox:  { background:"rgba(255,68,68,0.1)", border:"1px solid rgba(255,68,68,0.3)", borderRadius:8, padding:"12px 16px", fontSize:13, color:"#FF6666" },
  btn:       { background:"linear-gradient(135deg, #D4A017, #F0C040)", border:"none", borderRadius:10, padding:15, cursor:"pointer", fontSize:15, fontWeight:700, color:"#0A0A0F", marginTop:8, fontFamily:"inherit", boxShadow:"0 4px 20px rgba(212,160,23,0.3)" },
  footer:    { display:"flex", alignItems:"center", justifyContent:"center", gap:10, marginTop:28, paddingTop:20, borderTop:"1px solid rgba(212,160,23,0.1)" },
  footerText:{ fontSize:11, color:"#505060" },
  dot:       { color:"rgba(212,160,23,0.4)", fontSize:11 },
  bottomTag: { marginTop:24, fontSize:11, color:"#303040", letterSpacing:1.5, textTransform:"uppercase" },
};
